import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { getAuth } from 'firebase/auth';
import { from, switchMap } from 'rxjs';
import { AuthService } from './auth-service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);

  const idToken$ = authService.getIdToken();

  if (idToken$) {
    return idToken$.pipe(
      switchMap((token) => {
        let headers = req.headers.append('Authorization', token);
        const scopeContext = window.localStorage.getItem('scope');
        if (scopeContext) {
          headers = headers.append('x-scope-context', scopeContext);
        }
        const newRequest = req.clone({
          headers: headers,
        });
        return next(newRequest);
      }),
    );
  }
  return next(req);
};
